import { useRef, useEffect, useState } from 'react'
import { StyledSearch } from '@/components/styles'
import { useRouter } from 'next/router'
import Icon from '@/assets/icons'
import { useTranslation } from "react-i18next";

export default function Search({ onFormSubmit, shouldFocus = true }) {
  const input = useRef()
  const { query } = useRouter()
  const { title: searchQuery = '' } = query
  const { t } = useTranslation("global");

  const [inputValue, setInputValue] = useState(searchQuery)

  useEffect(() => {
    if (shouldFocus) {
      focusWithSelection(input.current)
    }
  }, [])

  const onSubmit = e => {
    e.preventDefault()
    const queryString = inputValue
    if (queryString.trim().length === 0) return

    onFormSubmit(queryString)
    focusWithSelection(input.current)
  }

  const onChange = e => {
    setInputValue(e.target.value)
  }

  const onReset = () => {
    setInputValue('')
    focusWithSelection(input.current)
  }

  function focusWithSelection(input) {
    input.focus()
    input.select()
  }

  return (
    <StyledSearch action="/" onSubmit={onSubmit}>
      <StyledSearch.Input
        type="text"
        placeholder={t('search.placeholder')}
        value={inputValue}
        ref={input}
        onChange={onChange}
      />

      <StyledSearch.Submit type="submit">
        <Icon name="search" />
      </StyledSearch.Submit>

      <StyledSearch.Reset type="reset" onClick={onReset} />
    </StyledSearch>
  )
}
